// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"95980e2c","508":"69528519","776":"5d51084f"}[chunkId] + ".chunk.js";
};